import React from 'react';
import {
  Table,
  TableRow,
  TableCell,
  Paper,
  TableHead,
  TableContainer,
  TableBody,
  Box,
  Typography,
} from '@mui/material';
import {
  Person as PersonIcon,
  Receipt as ReceiptIcon,
  CalendarToday as CalendarTodayIcon,
  AttachMoney as AttachMoneyIcon,
} from '@mui/icons-material';
import moment from 'moment';
export default function TFacturasTareas(props) {
  return (
    <TableContainer component={Paper} align="center">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell
              align="left"
              sx={{
                backgroundColor: '#e3f2fd',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
                borderBottom: 2,
                borderColor: 'primary.main',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PersonIcon sx={{ fontSize: 18 }} />
                Usuario
              </Box>
            </TableCell>
            <TableCell
              align="left"
              sx={{
                backgroundColor: '#e3f2fd',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
                borderBottom: 2,
                borderColor: 'primary.main',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PersonIcon sx={{ fontSize: 18 }} />
                Cliente
              </Box>
            </TableCell>
            <TableCell
              align="left"
              sx={{
                backgroundColor: '#e3f2fd',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
                borderBottom: 2,
                borderColor: 'primary.main',
              }}
            >
              Timbrado
            </TableCell>
            <TableCell
              align="left"
              sx={{
                backgroundColor: '#e3f2fd',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
                borderBottom: 2,
                borderColor: 'primary.main',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ReceiptIcon sx={{ fontSize: 18 }} />
                Comprobante
              </Box>
            </TableCell>
            <TableCell
              align="left"
              sx={{
                backgroundColor: '#e3f2fd',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
                borderBottom: 2,
                borderColor: 'primary.main',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CalendarTodayIcon sx={{ fontSize: 18 }} />
                Fecha Fac
              </Box>
            </TableCell>
            <TableCell
              align="left"
              sx={{
                backgroundColor: '#e3f2fd',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
                borderBottom: 2,
                borderColor: 'primary.main',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CalendarTodayIcon sx={{ fontSize: 18 }} />
                Fecha Vto
              </Box>
            </TableCell>
            <TableCell
              align="left"
              sx={{
                backgroundColor: '#e3f2fd',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
                borderBottom: 2,
                borderColor: 'primary.main',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <AttachMoneyIcon sx={{ fontSize: 18 }} />
                Total
              </Box>
            </TableCell>
            <TableCell
              align="left"
              sx={{
                backgroundColor: '#e3f2fd',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
                borderBottom: 2,
                borderColor: 'primary.main',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <AttachMoneyIcon sx={{ fontSize: 18 }} />
                Importe
              </Box>
            </TableCell>
            <TableCell
              align="left"
              sx={{
                backgroundColor: '#e3f2fd',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
                borderBottom: 2,
                borderColor: 'primary.main',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <AttachMoneyIcon sx={{ fontSize: 18 }} />
                Saldo
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.DataFact.map((factura) => (
            <TableRow
              key={factura.nrocomprobante}
              sx={{
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
                '&:nth-of-type(even)': {
                  backgroundColor: 'action.hover',
                },
              }}
            >
              <TableCell align="left">
                <Typography variant="body2">
                  {typeof factura.usuario === 'string'
                    ? factura.usuario
                    : factura.usuario?.nombrecompleto ||
                      factura.usuariofpc ||
                      '—'}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="body2">
                  {typeof factura.cliente === 'string'
                    ? factura.cliente
                    : `${factura.cliente?.nombre ?? ''} ${
                        factura.cliente?.apellido ?? ''
                      }`.trim() || factura.clientefpc || '—'}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="body2">{factura.timbrado}</Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="body2" fontWeight={600}>
                  {factura.nrocomprobante}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="body2">
                  {moment(factura.fechacomprobante).format('DD/MM/YYYY')}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="body2">
                  {moment(factura.fechavencimiento).format('DD/MM/YYYY')}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="body2" fontWeight={600} color="primary">
                  {Intl.NumberFormat('es').format(factura.totalfactura)}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="body2">
                  {Intl.NumberFormat('es').format(factura.montopagado)}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="body2" fontWeight={600} color="error">
                  {Intl.NumberFormat('es').format(
                    factura.totalfactura - factura.montopagado
                  )}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
